// Central GAELON WhatsApp configuration.
// Country code 55 (Brazil) + area code 11 (São Paulo) + local number.
export const GAELON_WHATSAPP_NUMBER = "5511914479621";
export const GAELON_WHATSAPP_DISPLAY = "+55 11 91447-9621";

// Locale-aware default greetings for the WhatsApp handoff.
const DEFAULT_MESSAGES = {
  "pt-br":
    "Olá GAELON, gostaria de agendar uma conversa estratégica sobre inteligência autônoma para minha organização.",
  en:
    "Hello GAELON, I'd like to book a strategy call about autonomous intelligence for my organization.",
  es:
    "Hola GAELON, me gustaría agendar una conversación estratégica sobre inteligencia autónoma para mi organización.",
  zh:
    "您好 GAELON,我想预约一次关于组织自主智能的战略会议。",
};

export function whatsappHref(locale = "en", customMessage) {
  const msg = (customMessage && customMessage.trim()) || DEFAULT_MESSAGES[locale] || DEFAULT_MESSAGES.en;
  return `https://wa.me/${GAELON_WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
}

export function openWhatsapp(locale = "en", customMessage) {
  if (typeof window === "undefined") return;
  window.open(whatsappHref(locale, customMessage), "_blank", "noopener,noreferrer");
}
